<div class="col">
    <a class="btn btn-primary w-100 collapsable" type="button" data-toggle="collapse"
        data-target="#multiCollapseExample2" aria-expanded="false"
        aria-controls="multiCollapseExample2"><i class="fa fa-location-arrow"></i>
        &nbsp; DOMESTIC TOPUP
        &nbsp;&nbsp;&nbsp;
        <img src="https://www.prid.io/retailer/public/carriers/at&t.png" style="max-width:2%;"> &nbsp;
        &nbsp;
        <img src="https://www.prid.io/retailer/public/carriers/boost-mobile.png" style="max-width:2%;">
        &nbsp; &nbsp;
        <img src="https://www.prid.io/retailer/public/carriers/simple-mobile.png" style="max-width:2%;">
        &nbsp; &nbsp;
        <img src="https://www.prid.io/retailer/public/carriers/t-mobile.png" style="max-width:2%;">
        &nbsp; &nbsp;
    </a>

    <div class="collapse multi-collapse" id="multiCollapseExample2">
        <div class="card card-body">

            <span class="widget-list-item row" *ngFor="let topUp of TopupList">
                <div *ngIf="topUp.productType==1" class="widget-list-media text-center col-lg-2">
                    <span style="font-size:9px;">{{topUp.prideReferenceNumber}} </span><br>
                    <img [src]="topUp.logoUrl" style="width: 45%;" class="rounded">
                </div>
                <div *ngIf="topUp.productType==1" class="col-5">
                    <h4 class="widget-list-title">{{topUp.accountNumber}}</h4>
                    <p style="font-size: 18px;" class="widget-list-desc"> {{topUp.providerName}} - <span
                            class="label label-info"><b>Topup</b></span>
                        &nbsp; <span class="label label-primary"> Recharge Date :{{topUp.creationTime |
                            date:'dd/MM/yyyy'}}</span>
                        <input type="hidden" name="name" value="">
                        <input type="hidden" name="phone" value="509-473-317-44">
                        <input type="hidden" name="mobile_no" value="1111111111">

                        <input type="hidden" name="country" value="HT">
                        <input type="hidden" name="provider" value="DCHT">
                        <input type="hidden" name="product" value="HT_DC_TopUp">

                        <input type="hidden" name="currency" value="">

                        <input type="hidden" name="logo"
                            value="https://imagerepo.ding.com/logo/DC/HT.png">

                        <input type="hidden" name="category_type" value="International">
                        <input type="hidden" name="country_text" value="Haiti">
                        <input type="hidden" name="provider_text" value="Digicel Haiti">
                        <input type="hidden" name="product_text" value="HTG 384.16-7010.92">
                        <input type="hidden" name="product_benefits" value="Topup">


                    </p>
                </div>

                <div *ngIf="topUp.productType==1" class="col-3 mt-3">
                    <div class="input-group ">
                        <div class="input-group-prepend">
                            <span class="input-group-button"> <button
                                    class="btn btn-xs btn-success addtocart  pull-right"
                                    data-id="top-add-cart-14840" data-form="topup" type="submit"><i
                                        style="font-size: 18px; padding: 10px;"
                                        class="fa fa-cart-plus"></i></button>
                            </span>

                        </div>
                        &nbsp;
                        <a href="javascript:;" data-remove="top-add-cart-14840"
                            data-url="https://www.prid.io/retailer/remove-number/14840"
                            style="background-color:#efaa45"
                            class="btn btn-xs btn-warning btn-remove-number ml-1"><i
                                style="font-size: 18px; padding: 10px; color: white;"
                                class="fa fa-trash"></i></a>

                    </div>
                </div>
            </span>
            <br>
            <div>
                <div class="row">
                    <div class="col-lg-2"></div>
                    <div class="col-lg-8">
                        <div class="row">
                            <b>Domestic Mobile No</b>
                            <div class="col-lg-2 mt-2" style="padding: 0px !important;">
                                <div class="form-group">
                                    <select class="form-control form-control-lg" id="countryCode"
                                        name="countryCode" [(ngModel)]="selectedCountryCode">
                                        <option value="+1" selected>+1 (USA)</option>
                                   </select>
                                </div>
                            </div>
                            <div class="col-lg-9 mt-2" style="padding: 0px !important;">
                                <input type="text" class="form-control form-control-lg"
                                    name="phoneNumber" #accountNo>
                            </div>
                            <div class="col-lg-1">
                                <i (click)="domesticNumberProcess(accountNo.value)"
                                    class="fa fa-arrow-right" style="font-size: 41px;"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <p style="color: red;"> {{domesticPhoneError}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">

                    </div>

                </div>
                <div class="row" *ngIf="boolShowProvider==true">
                    <div class="col-lg-2"></div>
                    <div class="col-lg-8">
                        <hr>
                        <h3>Provider</h3>
                        <ol *ngIf="selectedItem==null" class="domesticCards">
                            <li *ngFor="let item of dmstcProviderOptions"
                                (click)="onItemClick(item,accountNo.value)"
                                [class.selected]="selectedItem === item">
                                <div class="icon">
                                    <img style="width: 60px;" [src]="item.label2" />
                                </div>
                                <div class="descr">{{ item.label }}</div>
                            </li>
                        </ol>

                        <div *ngIf="selectedItem">
                            <ol class="domesticCards">
                                <li>
                                    <div class="icon"><img style="width: 60px;"
                                            src="{{selectedItem.label2}}"></div>
                                    <div class="descr">{{selectedItem.label}}</div>

                                </li>
                            </ol>
                            <a style="color:rgb(87, 87, 241); cursor: pointer;"
                                (click)="changeProvider()">Select Provider</a>
                    
                        </div>


                    </div>
                    <div class="col-lg-2"></div>
                </div>
                <div class="row" *ngIf="boolShowAmount==true">
                    <div class="col-lg-2"></div>
                    <div class="col-lg-8">
                        <hr>
                        <h3>Product</h3>
                        <ol *ngIf="selectedItemProduct==null" class="domesticProductCards">
                            <li *ngFor="let item of dmstcProductOptions"
                                (click)="onItemProductClick(item)"
                                [class.selected]="selectedItemProduct === item">
                                <div class="title">{{ item.label }}</div>
                                <div class="descr">{{ item.label }}
                                    will be received<br>
                                    *including bonus if applicable<br>
                                    *T&C's apply to bonus credit
                                </div>
                            </li>
                        </ol>

                        <div *ngIf="selectedItemProduct">
                            <ol class="domesticProductCards">
                                <li>
                                    <div class="title">{{ selectedItemProduct.label }}</div>
                                    <div class="descr">{{ selectedItemProduct.label }}
                                        will be received<br>
                                        *including bonus if applicable<br>
                                        *T&C's apply to bonus credit
                                    </div>
                                </li>
                            </ol>
                            <a style="color:rgb(87, 87, 241); cursor: pointer;"
                                (click)="backSelectProduct()">backSelectProduct</a>
                        </div>

                    </div>
                    <div class="col-lg-2"></div>
                </div>

                <div class="row" *ngIf="boolShowAmount==true">
                    <div class="col-lg-2"></div>
                    <div class="col-lg-8">
                        <b>Amount</b>
                        <input [value]="dmstcAmountValue" [disabled]="boolDmstcAmountValue"
                            type="number" class="form-control form-control-lg mt-2" #dmstcAmount>
                        <p *ngIf="boolAmountRange==true">Min price:
                            {{intlSelectedProduct.minimum.sendValue}} - Max price:
                            {{intlSelectedProduct.maximum.sendValue}}</p>
                    </div>
                    <div class="col-lg-2"></div>

                    <div class="col-lg-2"></div>
                    <div class="col-lg-4">
                        <b>First Name</b>
                        <input type="text" #DomesticFirstName class="form-control form-control-lg mt-2">
                    </div>
                    <div class="col-lg-4">
                        <b>Last Name</b>
                        <input type="text" #DomesticLastName class="form-control form-control-lg mt-2">
                    </div>
                    <div class="col-lg-2"></div>

                    <div class="col-lg-4"></div>
                    <div class="col-lg-4">
                        <button type="button" class="btn btn-dark"
                            (click)="AddToCartDomestic(dmstcAmount.value,'1',accountNo.value,DomesticFirstName.value,DomesticLastName.value)">Add
                            to
                            Cart</button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>


            </div>
        </div>
    </div>
</div>